"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/observable/interval");
var CountdownComponent = /** @class */ (function () {
    function CountdownComponent() {
        this.message = '';
        this.hasHours = true;
        this.hasMinutes = true;
        this.onCountdownEnd = new core_1.EventEmitter();
        this.resolvedMessage = '';
        this.intervalHandle = undefined;
    }
    CountdownComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.intervalHandle = setInterval(function () {
            var differenceInMinutes = Math.floor((_this.countdownStartDate - _this.getCurrentUTCDate()) / 1000);
            if (differenceInMinutes <= 0) {
                _this.onCountdownEnd.emit();
            }
            else {
                _this.resolvedMessage = _this.resolveMessage(_this.getPlaceholders(differenceInMinutes));
            }
        });
    };
    CountdownComponent.prototype.ngOnDestroy = function () {
        clearInterval(this.intervalHandle);
    };
    CountdownComponent.prototype.resolveMessage = function (placeholders) {
        var resolvedString = this.message;
        for (var i = 0; i < placeholders.length; ++i) {
            resolvedString = resolvedString.replace('{' + i + '}', placeholders[i]);
        }
        return resolvedString;
    };
    CountdownComponent.prototype.getPlaceholders = function (timer) {
        var placeholders = [];
        if (this.hasHours) {
            var hours = Math.floor(timer / 3600) % 24;
            hours < 10 ? placeholders.push('0' + hours) : placeholders.push(hours.toString());
            timer -= hours * 3600;
        }
        if (this.hasMinutes) {
            var minutes = Math.floor(timer / 60) % 60;
            minutes < 10 ? placeholders.push('0' + minutes) : placeholders.push(minutes.toString());
            timer -= minutes * 60;
        }
        var seconds = timer % 60;
        seconds < 10 ? placeholders.push('0' + seconds) : placeholders.push(seconds.toString());
        return placeholders;
    };
    CountdownComponent.prototype.getCurrentUTCDate = function () {
        var now = new Date();
        return now.getTime();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CountdownComponent.prototype, "message", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CountdownComponent.prototype, "hasHours", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CountdownComponent.prototype, "hasMinutes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], CountdownComponent.prototype, "countdownStartDate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], CountdownComponent.prototype, "onCountdownEnd", void 0);
    CountdownComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-countdown',
            template: require('./countdown.component.html'),
            styles: [require('./countdown.component.css')]
        })
    ], CountdownComponent);
    return CountdownComponent;
}());
exports.CountdownComponent = CountdownComponent;
//# sourceMappingURL=countdown.component.js.map